import { render, staticRenderFns } from "./form-item-phone.vue?vue&type=template&id=6eb39a14&"
import script from "./form-item-phone.vue?vue&type=script&lang=js&"
export * from "./form-item-phone.vue?vue&type=script&lang=js&"
import style0 from "./form-item-phone.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports